import { CamposGenericos } from "./camposGenericos"

export class ListaPrecioCabecera extends CamposGenericos {
   
    descripcion: string
    descuentoDiscrecional: boolean
    fechaValidaDesde: Date
    fechaValidaHasta: Date
    formaPago: string
    id: string
    idCompania: string
    idFormaPago: string
    idMoneda:string
    idPais: string
    idSalesOrg: string
    idTerminoPago: string
    precioFijo: boolean
    terminoPago: string
    usuarioRedUltimaActualizacion: string
    valorizacion: boolean
    defecto: boolean
}